import React, { Component } from "react";
import ProjectDetailsModal from "./ProjectDetailsModal";

function imgUrl(path) {
  if (!path || path.startsWith("http")) return path;
  return `${process.env.PUBLIC_URL}/${path}`;
}

function getBadge(url) {
  if (!url) return null;
  if (url.includes("steampowered.com")) return "Steam";
  if (url.includes("itch.io")) return "Itch.io";
  if (url.includes("legendsoflearning.com")) return "Web";
  if (url.includes("pixelperfectstudio")) return "Mobile";
  return "Web";
}

function getLinkLabel(url, ui) {
  if (!url) return null;
  if (url.includes("steampowered.com")) return ui.proj_steam  || "View on Steam";
  if (url.includes("itch.io"))          return ui.proj_itch   || "Play Now";
  if (url.includes("legendsoflearning.com")) return ui.proj_itch || "Play Now";
  if (url.includes("pixelperfectstudio")) return ui.proj_studio || "View Studio";
  return ui.proj_visit || "Visit Site";
}

const SPANS = ["s7", "s5", "s4", "s4", "s4", "s4", "s4", "s4", "s6", "s6"];

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      selectedProject: null,
    };
  }

  openModal(project) {
    this.setState({ modalOpen: true, selectedProject: project });
  }

  closeModal() {
    this.setState({ modalOpen: false, selectedProject: null });
  }

  render() {
    let sectionName = "Projects";
    let projects = null;

    if (this.props.resumeProjects && this.props.resumeBasicInfo) {
      sectionName = this.props.resumeBasicInfo.section_name.projects;
      const ui = this.props.resumeBasicInfo.ui || {};
      const visible = this.props.resumeProjects
        .filter((p) => !p.hidden)
        .sort((a, b) => (parseInt(b.startDate) || 0) - (parseInt(a.startDate) || 0))
        .slice(0, 10);

      projects = visible.map((p, i) => {
        const span = SPANS[i] || "s4";
        const badge = getBadge(p.url);
        const linkLabel = getLinkLabel(p.url, ui);
        return (
          <div className={`pc ${span}`} key={p.title}>
            <div className="pc-img">
              {p.images && p.images[0] ? (
                <img src={imgUrl(p.images[0])} alt={p.title} />
              ) : (
                <div className="pc-img-ph">🎮</div>
              )}
              {badge && <span className="pc-badge">{badge}</span>}
            </div>
            <div className="pc-body">
              <div className="pc-studio">{p.startDate}</div>
              <div className="pc-title">{p.title}</div>
              <div className="pc-desc">{p.description}</div>
              <div className="pc-tags">
                {p.technologies.map((t, j) => (
                  <span className="pc-tag" key={j}>
                    {t.name}
                  </span>
                ))}
              </div>
              <div className="pc-actions">
                {p.url && (
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pc-link"
                  >
                    {linkLabel}
                  </a>
                )}
                <button
                  className="pc-details-btn"
                  onClick={() => this.openModal(p)}
                >
                  {(this.props.resumeBasicInfo?.ui?.proj_details) || "Details"}
                </button>
              </div>
            </div>
          </div>
        );
      });
    }

    return (
      <section id="projects">
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <p className="sec-eye rv">{this.props.resumeBasicInfo?.ui?.proj_eyebrow || "Game Library"}</p>
          <h2 className="sec-h rv" style={{ transitionDelay: ".05s" }}>
            {this.props.resumeBasicInfo?.ui?.proj_prefix || "FEATURED"} <span>{sectionName}</span>{this.props.resumeBasicInfo?.ui?.proj_suffix ? ` ${this.props.resumeBasicInfo.ui.proj_suffix}` : ""}
          </h2>
          <div className="proj-grid">{projects}</div>
        </div>

        {this.state.modalOpen && (
          <ProjectDetailsModal
            data={this.state.selectedProject}
            onClose={() => this.closeModal()}
            ui={this.props.resumeBasicInfo?.ui || {}}
          />
        )}
      </section>
    );
  }
}

export default Projects;
